export class EntryPoint {
	name: string;
	value: boolean;
	code: string;
}
